export const GOODLOKA_FRONT_URL =
  process.env.REACT_APP_GOODLOKA_FRONT_URL || 'http://localhost:5173';

/** Page dépôt sur le front GoodLoka (route enfant `/games/deposit`). */
export const GOODLOKA_DEPOSIT_PATH = '/games/deposit';

/** Page compte sur le front GoodLoka (route enfant `/games/account`). */
export const GOODLOKA_ACCOUNT_PATH = '/games/account';

/** Page historique sur le front GoodLoka (route enfant `/games/history`). */
export const GOODLOKA_HISTORY_PATH = '/games/history';

export const redirectToGoodLoka = (): void => {
  window.location.href = GOODLOKA_FRONT_URL;
};

/**
 * Construit l'URL absolue vers la page de dépôt GoodLoka.
 * Utilise `URL` pour éviter les doubles slash si l'env se termine par `/`.
 */
export const getGoodlokaDepositUrl = (): string => {
  const base = GOODLOKA_FRONT_URL.endsWith('/')
    ? GOODLOKA_FRONT_URL
    : `${GOODLOKA_FRONT_URL}/`;
  return new URL(GOODLOKA_DEPOSIT_PATH.replace(/^\//, ''), base).toString();
};

export const redirectToGoodlokaDeposit = (): void => {
  window.location.href = getGoodlokaDepositUrl();
};

/**
 * Construit l'URL absolue vers la page compte GoodLoka.
 */
export const getGoodlokaAccountUrl = (): string => {
  const base = GOODLOKA_FRONT_URL.endsWith('/')
    ? GOODLOKA_FRONT_URL
    : `${GOODLOKA_FRONT_URL}/`;
  return new URL(GOODLOKA_ACCOUNT_PATH.replace(/^\//, ''), base).toString();
};

export const redirectToGoodlokaAccount = (): void => {
  window.location.href = getGoodlokaAccountUrl();
};

/**
 * Construit l'URL absolue vers la page historique GoodLoka.
 */
export const getGoodlokaHistoryUrl = (): string => {
  const base = GOODLOKA_FRONT_URL.endsWith('/')
    ? GOODLOKA_FRONT_URL
    : `${GOODLOKA_FRONT_URL}/`;
  return new URL(GOODLOKA_HISTORY_PATH.replace(/^\//, ''), base).toString();
};

export const redirectToGoodlokaHistory = (): void => {
  window.location.href = getGoodlokaHistoryUrl();
};
